/**
 * Settings tracking events.
 *
 * Naming: `settings.<action>` — all snake_case.
 */

import { capture } from "./capture";

export const SettingsTracking = {
  // ── User management ──

  /** User invited via the invite modal. */
  userInvited: (role: string) => {
    capture("settings.user_invited", { role });
  },

  /** User role changed via the role dropdown. */
  userRoleChanged: (user_id: string, new_role: string) => {
    capture("settings.user_role_changed", { user_id, new_role });
  },

  /** User deactivated via the actions menu. */
  userDeactivated: (user_id: string) => {
    capture("settings.user_deactivated", { user_id });
  },

  /** User deleted via the actions menu. */
  userDeleted: (user_id: string) => {
    capture("settings.user_deleted", { user_id });
  },

  /** User reinvited via the actions menu. */
  userReinvited: (user_email: string) => {
    capture("settings.user_reinvited", { user_email });
  },

  // ── Tags ──

  /** Tag created. */
  tagCreated: (tag_type: string) => {
    capture("settings.tag_created", { tag_type });
  },

  /** Tag edited. */
  tagEdited: (tag_id: string) => {
    capture("settings.tag_edited", { tag_id });
  },

  /** Tag deleted. */
  tagDeleted: (tag_id: string) => {
    capture("settings.tag_deleted", { tag_id });
  },

  // ── SSO ──

  /** SSO configured successfully. */
  ssoConfigured: (sso_provider: string) => {
    capture("settings.sso_configured", { sso_provider });
  },

  // ── Beta features ──

  /** Beta feature toggled on or off. */
  betaFeatureToggled: (feature_key: string, enabled: boolean) => {
    capture("settings.beta_feature_toggled", { feature_key, enabled });
  },

  // ── Notification channels ──

  /** Notification channel added. */
  notificationChannelAdded: (channel_type: string) => {
    capture("settings.notification_channel_added", { channel_type });
  },

};
